// src/components/dashboard/CreateRequestCards.jsx
import { useNavigate } from 'react-router-dom';
import styles from './CreateRequestCards.module.css';
import { REQUEST_CARDS } from '../../data/cards';
import { ICONS } from '../../data/icons.jsx';

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

/**
 * A single card in the "Create Request" grid.
 */
function RequestCard({ id, title, description, cta = 'Open request', onClick }) {
  const icon = ICONS[id] ?? null;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className={styles.card}
      role="button"
      tabIndex={0}
      aria-label={title}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.iconWrap}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {icon}
        </svg>
      </div>

      <p className={styles.cardTitle}>{title}</p>
      <p className={styles.cardDesc}>{description}</p>

      <div className={styles.footer}>
        <span className={styles.cta}>{cta}</span>
        <div className={styles.arrow}>
          <ArrowIcon />
        </div>
      </div>
    </div>
  );
}

/**
 * Responsive grid of all request type cards.
 */
export default function CreateRequestCards() {
  const navigate = useNavigate();

  const handleCardClick = (card) => {
    if (card.id === 'customer-experience') {
      navigate('/customer?onBehalf=true');
      return;
    }
    navigate(`/staff/request/${card.id}`);
  };

  return (
    <div className={styles.section}>
      <p className={styles.sectionLabel}>Contact us about</p>
      <div className={styles.grid}>
        {REQUEST_CARDS.map((card) => (
          <RequestCard
            key={card.id}
            {...card}
            onClick={() => handleCardClick(card)}
          />
        ))}
      </div>
    </div>
  );
}
